<template>
    <div class="e-table-product animation-opacity">
        <table class="e-table-product__table">
            <thead>
                <tr>
                    <th width="50px">
                        <h1 class="app-title-dark text-center">N°</h1>
                    </th>
                    <th>
                        <h1 class="app-title-dark text-left">Producto</h1>
                    </th>
                    <th>
                        <h1 class="app-title-dark text-left">Código Barra</h1>
                    </th>
                    <th>
                        <h1 class="app-title-dark text-left">Cantidad</h1>
                    </th>
                    <th>
                        <h1 class="app-title-dark text-left">Ubicación</h1>
                    </th>
                    <th>
                        <h1 class="app-title-dark text-left">Tipo Producto</h1>
                    </th>
                    <th>
                        <h1 class="app-title-dark text-left">Laboratorio</h1>
                    </th>
                    <th>
                        <h1 class="app-title-dark text-center">Acciones</h1>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(product, index) in products"
                    :key="index"
                >
                    <td>
                        <h1 class="app-subtitle text-right">
                            {{(index+1)}}
                        </h1>
                    </td>
                    <td>
                        <text-highlight
                            class="app-subtitle"
                            :queries="search"
                        >
                            {{product.product}}
                        </text-highlight>
                    </td>
                    <td>
                        <text-highlight
                            class="app-subtitle"
                            :queries="search"
                        >
                            {{product.barcore!=null ? product.barcore : "S/CB"}}
                        </text-highlight>
                    </td>
                    <td>
                        <h1 class="app-subtitle">
                            {{product.quantity}}
                        </h1>
                    </td>
                    <td>
                        <h1 class="app-subtitle">
                            {{product.location}}
                        </h1>
                    </td>
                    <td>
                        <h1 class="app-subtitle">
                            {{product.type_product.type_product}}
                        </h1>
                    </td>
                    <td>
                        <h1 class="app-subtitle">
                            {{product.laboratory.laboratory}}
                        </h1>
                    </td>
                    <td class="d-flex justify-center flex-wrap">
                        <OBtnToolTipTableComp
                            :smsToolTip="`Ver detalle de: ${product.product}`"
                            icon="mdi-list-box"
                            @click="$emit('clickdetail', product)"
                        />
                        <OBtnToolTipTableComp
                            :smsToolTip="`Ver inventario manual de: ${product.product}`"
                            icon="mdi-medication"
                            @click="$emit('clickinventories', product)"
                        />
                        <OBtnToolTipTableComp
                            :smsToolTip="`Agregar lote: ${product.product}`"
                            icon="mdi-folder-plus"
                            @click="$emit('clicklot', product)"
                        />
                    </td>
                </tr>
                <tr v-if="products.length === 0">
                    <td colspan="8">
                        <h1 class="app-subtitle text-center">
                            SIN INFORMACIÓN
                        </h1>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import TextHighlight from "vue-text-highlight";
import { OBtnToolTipTableComp } from "../organisms";
export default {
    props: {
        products: Array,
        search: {
            type: String,
            default: ''
        }
    },
    components: {
        OBtnToolTipTableComp,
        TextHighlight
    }
}
</script>